import { render } from "./CandidateLayout.vue?vue&type=template&id=4a2e271f&scoped=true"
import script from "./CandidateLayout.vue?vue&type=script&lang=js"
export * from "./CandidateLayout.vue?vue&type=script&lang=js"

import "./CandidateLayout.vue?vue&type=style&index=0&id=4a2e271f&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2e271f"]])

export default __exports__